// extracted by mini-css-extract-plugin
module.exports = {"EditUser-Btns":"EditUser_EditUser-Btns__5b53y","EditUser-DeleteBtn":"EditUser_EditUser-DeleteBtn__3lfvU"};